export const SLIDE_EVENT_LABEL = 'Featured Slide Show - Scroll';

export const CTA_EVENT_LABEL = 'Featured Slide Show - CTA click';
